// @flow
import React, { Component, type Node } from 'react';
import styled from 'styled-components';

import type { Flavor } from './types';

import { mergeClassNames } from 'utils/functions';

type ButtonSize = 'lg' | 'sm' | '';

type ButtonProps = {
    /** determines the color of the button */
    flavor: Flavor,
    /** determines the size of the button */
    size: ButtonSize,
    /** optionally use bootstrap's 'outline' button style */
    outline: Boolean,
    /** optionally use block level buttons */
    block: Boolean,
    /** will be appended to the classes */
    className: string,
    /** what will be rendered inside the button */
    children: Node,
};

// sync with the LinkButton
const StyledButton = styled.button`
    border: none;
    border-radius: ${props => props.theme.radiusSm};
    cursor: pointer;
    &.btn-link {
        padding: 0 0.75rem;
    }
`;

/** A component for a button. */
export class Button extends Component<ButtonProps> {
    static defaultProps = {
        flavor: 'secondary',
        className: '',
        outline: false,
        block: false,
        size: '',
    };

    render() {
        let {
            flavor,
            size,
            className,
            outline,
            block,
            children,
            ...domProps
        } = this.props;
        className = mergeClassNames(
            'btn',
            outline ? `btn-outline-${flavor}` : `btn-${flavor}`,
            `${size ? 'btn-' + size : ''}`,
            block ? 'btn-block' : '',
            className
        );

        return (
            <StyledButton type='button' className={className} {...domProps}>
                {children}
            </StyledButton>
        );
    }
}

export default Button;
